<template>
  <div>
    <!-- Search -->
    <button @click="getTaskDefinitions">Refresh</button>
    <DataTable
      :rowKeys="['name']"
      :rows="taskDefinitions"
      :actions="
        readOnly
          ? [
              {
                name: 'taskDefinition',
                label: 'View',
                params: { name: 'taskType' }
              }
            ]
          : [
              {
                name: 'taskDefinition',
                label: 'View',
                params: { name: 'taskType' }
              },
              {
                name: 'taskDefinitionEdit',
                label: 'Edit',
                params: { name: 'taskType' }
              }
            ]
      "
      :columns="[
        { name: 'name', type: 'text' },
        { name: 'createTime', type: 'date' },
        { name: 'updateTime', type: 'date' },
        { name: 'description', type: 'text' }
      ]"
    />
    <!-- Pagination -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import DataTable from '@/components/DataTable.vue'

export default {
  name: 'TaskDefinitionList',
  computed: {
    ...mapGetters({
      taskDefinitions: 'taskDefinitionsOrderByCreateTimeDesc'
    }),
    ...mapState(['readOnly'])
  },
  methods: mapActions(['getTaskDefinitions']),
  created() {
    this.getTaskDefinitions()
  },
  components: {
    DataTable
  }
}
</script>
